<template>
  <b-table-simple class="table-custom-field">
    <b-thead>
      <b-tr>
        <template v-for="field in computedFields">
          <b-th
            v-if="['drag_action', 'button_action'].includes(field.key)"
            :key="field.key"
            class="table-custom-field__header-action"
          />
          <b-th v-else :key="field.key">
            {{ field.label }}
          </b-th>
        </template>
      </b-tr>
    </b-thead>

    <b-tbody v-if="isLoading">
      <b-tr v-for="n in 5" :key="n">
        <b-td v-for="i in computedFields" :key="i">
          <b-skeleton />
        </b-td>
      </b-tr>
    </b-tbody>

    <b-tbody v-else-if="localItems.length == 0">
      <b-tr>
        <b-td :colspan="computedFields.length" class="text-center">{{
          $t('global.emptyTable')
        }}</b-td>
      </b-tr>
    </b-tbody>

    <draggable v-else v-model="localItems" :tag="'b-tbody'" handle=".drag_action" @change="handleChangeDraggable">
      <b-tr v-for="item in localItems" :key="item.name">
        <template v-for="field in computedFields">
          <b-td
            v-if="field.key == 'drag_action'"
            :key="field.key"
            class="table-custom-field__drag-column"
          >
            <i class="drag_action icon-outline_move"></i>
          </b-td>
          <b-td
            v-else-if="field.key == 'button_action'"
            :key="field.key"
            class="table-custom-field__button-action"
          >
            <b-button
              variant="outline"
              class="table-custom-field__edit-button"
              @click="$emit('click-edit', { item })"
            >
              <i class="mc-icon icon-outline_edit"></i>
            </b-button>

            <b-button
              variant="outline"
              class="table-custom-field__delete-button"
              @click="$emit('click-delete', { item })"
            >
              <i class="mc-icon icon-outline_trash"></i>
            </b-button>
          </b-td>
          <b-td v-else :key="field.key">
            <slot :name="`cell(${field.key})`" :item="item" :value="item[field.key]">
              {{ item[field.key] }}
            </slot>
          </b-td>
        </template>
      </b-tr>
    </draggable>
  </b-table-simple>
</template>

<script>
import draggable from 'vuedraggable'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    draggable,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['drag', 'click-edit', 'click-delete'],
  data() {
    return {
      drag: false,
      localItems: this.items,
    }
  },
  computed: {
    computedFields() {
      return [
        {
          key: 'drag_action',
        },
        ...cloneDeep(this.fields),
        {
          key: 'button_action',
        },
      ]
    },
  },
  watch: {
    items(newValue) {
      this.localItems = newValue
    }
  },
  methods: {
    handleChangeDraggable({ moved }) {
      this.$emit('drag', moved)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-custom-field {
  &__header-action {
    width: 80px;
  }

  td {
    i {
      font-size: 20px;
      cursor: pointer;
    }
  }

  &__button-action {
    display: flex;
    justify-content: space-between;
  }

  &__drag-column,
  &__edit-button,
  &__delete-button {
    i {
      color: $mep-color-text-400;
    }
  }

  &__edit-button,
  &__delete-button {
    padding: 0;
  }

  &__delete-button {
    i:before {
      color: $red;
    }
  }
}
</style>
